type Props = {
  className?: string;
};

const SearchIcon = ({ className }: Props) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle
      cx="9"
      cy="9"
      r="6.25"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M13.75 13.75L17 17"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default SearchIcon;
